"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateReturnOnEquity = void 0;
const zod_1 = require("zod");
const xirr_1 = __importDefault(require("xirr"));
const cashFlowColumnWithDate = zod_1.z.array(zod_1.z.object({
    date: zod_1.z.coerce.date(),
    cashFlow: zod_1.z.number(),
}));
const calculateReturnOnEquity = ({ cashFlowTable, sharePrice, totalNumOfShares }) => {
    const parsedCashflowTable = cashFlowColumnWithDate.parse(cashFlowTable);
    const firstRow = { amount: sharePrice * totalNumOfShares * -1, when: new Date() };
    const irrInput = [firstRow, ...parsedCashflowTable.map((v) => ({ amount: v.cashFlow, when: v.date }))];
    return (0, xirr_1.default)(irrInput);
};
exports.calculateReturnOnEquity = calculateReturnOnEquity;
//# sourceMappingURL=returnOnEquity.js.map